import type { TError, TSaveFormProgress } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';
import type { TFormSubmission } from './start-submission';

interface SaveFormProgressInput {
  submissionId: string;
  data: TSaveFormProgress;
}

/**
 * Hook to persist partial answers for an in-progress form submission.
 * Does not change submission status — call useSubmitForm to finalize.
 */
export const useSaveFormProgress = () => {
  const queryClient = useQueryClient();

  return useMutation<TFormSubmission, TError, SaveFormProgressInput>({
    mutationFn: async ({ submissionId, data }) => {
      const res = await axios.patch<TFormSubmission>(`/community-hub/form-submissions/${submissionId}/progress`, data);
      return res.data;
    },
    onSuccess: result => {
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'form-submission', result.id] });
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'form', result.formId, 'submissions'] });
    },
  });
};
